import i18n from '@/utils/i18n';
import React from 'react';
import { displayCurrencyPlaceholder, formatCurrency } from '@/utils/money';
import { MenuItem } from '@/contexts/menu-info-context';
import { MenuItemActions } from './menu-item-actions';
import { MenuItemPriceInputs } from './menu-item-price-inputs';
import { StyleSheet, Text, View } from 'react-native';
import { TYPOGRAPHY } from '@/styles';
import { useLayoutContext } from '@/contexts/layout-context';
import { useVariantPackInfoContext } from '@/contexts/variant-pack-info-context';

interface Props {
  menuItem: MenuItem;
  onDelete: () => void;
}

export const MenuItemPriceHeader: React.FC<Props> = ({
  menuItem,
  onDelete,
}) => {
  const { isLargeLayout } = useLayoutContext();
  const { currencyCode } = useVariantPackInfoContext();

  return (
    <View style={styles.base}>
      <View style={styles.row}>
        <Text style={[TYPOGRAPHY.h2, styles.title]}>{menuItem.name}</Text>
        <MenuItemActions menuItem={menuItem} onDelete={onDelete} />
      </View>
      {menuItem.ingredients.length ? (
        isLargeLayout ? (
          <View style={styles.row}>
            <MenuItemPriceInputs menuItem={menuItem} style={styles.priceRow} />
            <View style={styles.priceColumn}>
              <Text style={[TYPOGRAPHY.p, styles.totalPriceLabel]}>
                {i18n.t('menu_item.total_plate_cost')}
              </Text>
              <Text style={[TYPOGRAPHY.h2, styles.totalPrice]}>
                {menuItem.plateCostInMicros
                  ? formatCurrency(menuItem.plateCostInMicros, currencyCode)
                  : displayCurrencyPlaceholder(currencyCode)}
              </Text>
            </View>
          </View>
        ) : (
          <>
            <View style={styles.row}>
              <Text style={[TYPOGRAPHY.p, styles.totalPriceLabelTablet]}>
                {i18n.t('menu_item.total_plate_cost')}
              </Text>
              <Text
                style={[
                  TYPOGRAPHY.h3Bold,
                  styles.totalPrice,
                  styles.totalPriceTablet,
                ]}
              >
                {menuItem.plateCostInMicros
                  ? formatCurrency(menuItem.plateCostInMicros, currencyCode)
                  : displayCurrencyPlaceholder(currencyCode)}
              </Text>
            </View>
            <View style={styles.tabletPricingRow}>
              <MenuItemPriceInputs
                menuItem={menuItem}
                style={[styles.tabletPricingRow, styles.priceRow]}
              />
            </View>
          </>
        )
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  base: {
    paddingBottom: 16,
    paddingHorizontal: 16,
    paddingTop: 32,
  },
  priceColumn: {
    flexDirection: 'column',
    justifyContent: 'space-between',
    textAlign: 'right',
  },
  priceRow: {
    gap: 14,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  tabletPricingRow: {
    marginTop: 8,
  },
  title: {
    marginBottom: 16,
  },
  totalPrice: {
    textAlign: 'right',
  },
  totalPriceLabel: {
    fontSize: 14,
  },
  totalPriceLabelTablet: {
    fontSize: 18,
  },
  totalPriceTablet: {
    lineHeight: 18,
  },
});
